import { Component, OnInit } from '@angular/core';
import { TotalProductionService } from './total-production.service';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { TranslatePipe } from '@ngx-translate/core';
import { CulturalPipe } from '../../../../pipes/cultural.pipe';

@Component({
    selector: 'app-total-production',
    imports: [TranslatePipe, CulturalPipe],
    templateUrl: './total-production.html',
    styleUrl: './total-production.scss'
})
export class TotalProduction {

    constructor(
        public themeService: CustomizerSettingsService,
        private totalProductionService: TotalProductionService
    ) { }

    ngAfterViewInit(): void {
        this.totalProductionService.loadChart();
    }

    ngOnDestroy(): void {
        this.totalProductionService.destroyChart();
    }

}